import moment from 'moment';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

export function momentInstance(value?: string | Date, format: string = environment.dateFormatSystem) {
  return value ? moment(value, format) : moment();
}

export function getMoment(date: any, format?: string): moment.Moment {
  return moment(date, format);
}

export function getMomentFormat(date: any, format?: string): string {
  return moment(date).format(format);
}

export function date(): Date {
  return new Date();
}

export function time(): string {
  return moment().format(environment.timeFormat);
}

export function dateToNgb(date: Date): NgbDate {
  return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

export function ngbToDate(ngbdate: NgbDate): Date {
  return new Date(ngbdate.year, ngbdate.month - 1, ngbdate.day);
}

export function dateToString(date: Date): string {
  const format = environment.dateFormatSystem;
  return moment(date).format(format);
}

export function stringToDate(date: string): Date {
  return moment(date, environment.dateFormatSystem).toDate();
}

export function stringToNgb(date: string): NgbDate {
  return dateToNgb(stringToDate(date));
}

export function ngbToString(date: NgbDate): string {
  return dateToString(ngbToDate(date));
}

export function dateToDatetimeString(date: Date): string {
  return moment(date).format(`${environment.dateFormatSystem} ${environment.timeFormat}`);
}

/**
 * Devuelve la diferencia en milisegundos entre ahora y la fecha clientiada por argumento
 *
 * @param date objeto moment
 */
export function difference(date: moment.Moment) {
  const then = date as any;
  const now = moment() as any;
  const diff = now - then;
  return diff;
}

export function formatToHours(value: string) {
  const d = new Date(value);
  const h = d.getHours();
  const m = d.getMinutes();
  const s = d.getSeconds();

  return `${h}:${m}:${s}`;
}

export function datetoBackendFormat(value: Date): string {
  const now = new Date();
  const year = value.getFullYear();
  const month = value.getMonth() + 1 < 10 ? `0${value.getMonth() + 1}` : value.getMonth() + 1;
  const day = value.getDate() < 10 ? `0${value.getDate()}` : value.getDate();
  const hour = now.getHours() < 10 ? `0${now.getHours()}` : now.getHours();
  const minute = now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes();

  return `${year}-${month}-${day}T${hour}:${minute}`;
}
